import { lazy } from "react";
import { Route } from "react-router-dom";
import { Environment } from "@lyfegen-platform/graphql-schema/models";

const SimulatorOverview = lazy(() => import("../../containers/simulator/Overview"));
const SimulatorDetails = lazy(() => import("../../containers/simulator/details/Overview"));
const SimulatorComparison = lazy(() => import("../../containers/simulator/comparison/Overview"));

export default function Key81Routes(key: string, link: string, serverEnvironment: Environment) {
	const key81Routes = [
		{ link: link + "/", component: (props: any) => <SimulatorOverview {...props} /> },
		{ link: link + "/create", component: (props: any) => <SimulatorDetails {...props} serverEnvironment={serverEnvironment} /> },
		{ link: link + "/comparison", component: (props: any) => <SimulatorComparison {...props} serverEnvironment={serverEnvironment} /> },
		{ link: link + "/groups", component: (props: any) => <SimulatorOverview {...props} /> },
		{ link: link + "/:id", component: (props: any) => <SimulatorDetails {...props} serverEnvironment={serverEnvironment} /> },
		{
			link: link + "/copy/:id",
			component: (props: any) => <SimulatorDetails {...props} copyCreation={true} serverEnvironment={serverEnvironment} />,
		},
	];
	return key81Routes.map((r, i) => <Route exact key={i} path={r.link} render={r.component} />);
}
